import React from 'react';
import './reviews.css'
import C2wReviewCard from '../../../../common/C2wHome/courseDetails/reviewCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

function C2wReviews({ courseData }) {

  /**
 * @constant renderedReviewsCard
 * @author Vishal Lohbande
 * @description Maps over the `courseData` array to render a list of `C2wReviewCard` components.
 * Each component receives an individual review object (`obj`) as a prop.
 * 
 * @returns {JSX.Element[]} Array of `C2wReviewCard` components
 * 
 * Usage:
 * Used to display a list of reviews related to the course.
 */

  return (
    <div className='C2wReviews_ctn'>
      <div className='C2wCoureseDetailComponentHeading_ctn'>
        <div className='C2wReviews_testimonialHeading'>{'Testimonials'}</div>
        <div className='heading'>
          {`${'What '} `}
          <span className='headingSpan'>{`${'Students say '}`}</span>
          {'about this course?'}
        </div>
      </div>
      <div className='C2wReviews_holder'>
        {/* {renderedReviewsCard} */}
        <Swiper
          modules={[Autoplay]}
          slidesPerView={3}
          navigation={false}
          loop={false}
          className=" "
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            360: {
              slidesPerView: 1,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 80,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 80,
            },
          }}
        >
          {courseData?.map((obj, index) => (
            <SwiperSlide className='C2wReviewSwiperSlide'>
              <C2wReviewCard obj={obj} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default C2wReviews
